import { render, staticRenderFns } from "./InquiryEdit.vue?vue&type=template&id=3dc70bb0&scoped=true&"
import script from "./InquiryEdit.vue?vue&type=script&lang=js&"
export * from "./InquiryEdit.vue?vue&type=script&lang=js&"
import style0 from "./InquiryEdit.vue?vue&type=style&index=0&id=3dc70bb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc70bb0",
  null
  
)

export default component.exports